import request from '../utils/request';
import { IResult } from '../global';
import { IComment } from '../components/ComponentCommentList/AllForCommentList';
import stat from '../utils/stat';

interface IPost {
  content: string;
  galleryid: string;
}

const commentListCanUseCache = () => {
  let time = Number(
    window.localStorage.getItem(`comment_t_${window.gallery.id}`) || 0
  );
  if (Date.now() - time > 2 * 60 * 1000) {
    return false;
  } else {
    if (
      Number(
        window.localStorage.getItem(`comment_message_${window.gallery.id}`)
      ) > 0
    ) {
      return true;
    } else {
      return false;
    }
  }
};

export const setCommentListCanUserCache = () => {
  let time = Number(
    window.localStorage.getItem(`comment_t_${window.gallery.id}`) || 0
  );
  if (Date.now() - time > 2 * 60 * 1000) {
    window.localStorage.removeItem(`comment_message_${window.gallery.id}`);
    window.localStorage.setItem(
      `comment_t_${window.gallery.id}`,
      Date.now() + ''
    );
  }
};

const comment = {
  //删除
  del: (id: number) => {
    return new Promise((resolve, reject) => {
      request({
        url: '/api/v2/comment/del',
        method: 'post',
        data: { id },
        headers: {
          Authorization: request.token
        }
      })
        .then(jsonData => {
          resolve(jsonData);
        })
        .catch(reject);
    });
  },
  giftlist: (galleryid: number) => {
    return new Promise<IResult>((resolve, reject) => {
      request({
        url: '/api/v2/gallery/show?id=' + galleryid + '&_with=gift_detail'
      })
        .then(jsonData => {
          resolve(jsonData);
        })
        .catch(reject);
    });
  },
  emotionlist: (galleryid: number) => {
    return new Promise<IResult>((resolve, reject) => {
      request({
        url: '/api/v2/gallery/show?id=' + galleryid + '&_with=emotion_detail'
      })
        .then(jsonData => {
          resolve(jsonData);
        })
        .catch(reject);
    });
  },
  post: (data: IComment) => {
    stat.event('event_comments');
    return new Promise<IResult>((resolve, reject) => {
      request({
        url: '/api/v2/comments/add',
        method: 'post',
        data: data,
        headers: {
          Authorization: request.token
        }
      })
        .then(jsonData => {
          resolve(jsonData);
          setCommentListCanUserCache();
        })
        .catch(reject);
    });
  },
  list: (
    gallery_id: number,
    sort: string,
    lastid: number = 0,
    useTop: boolean = true,
    filter?: any
  ) => {
    let oper = '<[id]';
    let order = 'desc';
    if (sort == 'early') {
      oper = '>[id]';
      order = 'asc';
    }

    let getData = {
      reply_id: 0,
      [oper]: lastid,
      '_order[id]': order
    };
    if (sort == 'question') {
      getData.type = 'question';
    }
    if (sort == 'danmuku') {
      getData.type = 'text';
    }
    if (sort == 'text') {
      // RED_PACKAGE = 'redpackage',
      // EMOTION = 'emotion',
      // GIFT = 'gift',
      // FILE = 'file',
      // IMAGE = 'image',
      // TEXT = 'text',
      // QUESTION = 'question',
      // HTML = 'html'
      getData['_in[type]'] = [
        'text',
        'html',
        'image',
        'file',
        'redpackage',
        'question'
      ].join(',');
    }

    if (!useTop) {
      getData.is_top = 0;
    }

    if (filter && Object.keys(filter).length) {
      getData = {
        ...getData,
        ...filter
      };
    }

    const useNoCache =
      commentListCanUseCache() &&
      (lastid == Number.MAX_SAFE_INTEGER || typeof lastid == 'undefined');

    return new Promise<IResult>((resolve, reject) => {
      request({
        url: '/api/v2/comments/' + gallery_id + '/list',
        data: getData,
        headers: useNoCache
          ? {
              'Cache-Control': 'no-cache'
            }
          : null
      })
        .then(res => {
          setCommentListCanUserCache();
          resolve(res);
        })
        .catch(reject);
    });
  },
  replylist: (ids: number[]) => {
    return new Promise<IResult>((resolve, reject) => {
      request({
        url: '/api/v2/comments/replylist',
        data: {
          ids: ids,
          _limit: 20
        }
      })
        .then(res => {
          resolve(res);
        })
        .catch(reject);
    });
  },
  isblock: () => {
    return new Promise<IResult>((resolve, reject) => {
      request({
        url: `/api/v2/block/${window.gallery.orderid}/selfinfo`,
        headers: {
          Authorization: request.token
        }
      }).then(res => {
        resolve(res);
      });
    });
  }
};

export default comment;
